import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const pageRoutes = [
  <Route
    key="debug-koneksi"
    exact
    path="/debug-koneksi"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/DebugKoneksi")}
      />
    )}
  />,
  <Route
    key="home"
    exact
    path="/"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Home")}
      />
    )}
  />,
  <Route
    key="about"
    exact
    path="/about"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/About")}
      />
    )}
  />,
  <Route
    key="terms"
    exact
    path="/terms"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Terms")}
      />
    )}
  />,
  <Route
    key="jobs"
    exact
    path="/jobs"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Jobs")}
      />
    )}
  />,
  <Route
    key="mitra"
    exact
    path="/mitra"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Mitra")}
      />
    )}
  />,
  <Route
    key="mentor"
    exact
    path="/mentor"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Mentor")}
      />
    )}
  />,
  <Route
    key="mau-jadi-mentor"
    exact
    path="/mau-jadi-mentor"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/MauJadiMentor")}
      />
    )}
  />,
  <Route
    key="regulasi"
    exact
    path="/regulasi"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Regulasi")}
      />
    )}
  />,
  <Route
    key="farmasi"
    exact
    path="/farmasi"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Farmasi")}
      />
    )}
  />,
  <Route
    key="teknologi"
    exact
    path="/teknologi"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Teknologi")}
      />
    )}
  />,
  <Route
    key="uji"
    exact
    path="/uji"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/page/Uji")}
      />
    )}
  />,
  <Route
    key="contact"
    exact
    path="/contact"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Contact")}
      />
    )}
  />,
  <Route
    key="privacy-policy"
    exact
    path="/privacy_policy"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Privacy")}
      />
    )}
  />
];

export default pageRoutes; 